import { AccountAvatar, AccountInfo, Col, Row } from '@/components';
import type { ComponentProps, FC } from 'react';
import { useNavigate } from 'react-router';

type Props = {
  collapsed?: boolean;
} & ComponentProps<typeof AccountInfo>;

export const Account: FC<Props> = ({
  accountName,
  iconUrl,
  organizationName,
  collapsed,
}) => {
  const navigate = useNavigate();

  return (
    <button
      type="button"
      style={{
        width: '100%',
        padding: 16,
        border: 0,
        backgroundColor: 'transparent',
        cursor: 'pointer',
        textAlign: 'left',
      }}
      onClick={() => {
        navigate('/profile');
      }}
    >
      {!collapsed && (
        <AccountInfo
          accountName={accountName}
          iconUrl={iconUrl}
          organizationName={organizationName}
        />
      )}
      {collapsed && (
        <Row justify="center" align="middle">
          <Col>
            <AccountAvatar iconUrl={iconUrl} />
          </Col>
        </Row>
      )}
    </button>
  );
};
